import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

export const API = `${BACKEND_URL}/api`;

// Create axios instance with credentials for httpOnly cookies
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Bearer fallback token (also sent alongside cookies when available)
let bearerToken = null;

export function setBearerToken(token) {
  bearerToken = token || null;
  if (bearerToken) {
    api.defaults.headers.common["Authorization"] = `Bearer ${bearerToken}`;
  } else {
    delete api.defaults.headers.common["Authorization"];
  }
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Tasks API
export async function listTasks() {
  const { data } = await api.get("/tasks");
  return data;
}

export async function createTask(task) {
  const { data } = await api.post("/tasks", task);
  return data;
}

export async function updateTask(id, updates) {
  const { data } = await api.patch(`/tasks/${id}`, updates);
  return data;
}

export async function deleteTask(id) {
  const { data } = await api.delete(`/tasks/${id}`);
  return data;
}

// Snippets API
export async function listSnippets(categoryId) {
  const params = categoryId ? { category_id: categoryId } : {};
  const { data } = await api.get("/snippets", { params });
  return data;
}

export async function createSnippet(snippet) {
  const { data } = await api.post("/snippets", snippet);
  return data;
}

export async function searchSnippets(q) {
  const { data } = await api.get("/snippets/search", { params: { q } });
  return data;
}

export async function updateSnippet(id, updates) {
  const { data } = await api.patch(`/snippets/${id}`, updates);
  return data;
}

export async function deleteSnippet(id) {
  const { data } = await api.delete(`/snippets/${id}`);
  return data;
}

// Categories API
export async function listCategories() {
  const { data } = await api.get("/categories");
  return data;
}

export async function createCategory(payload) {
  const { data } = await api.post("/categories", payload);
  return data;
}

export async function updateCategory(id, updates) {
  const { data } = await api.patch(`/categories/${id}`, updates);
  return data;
}

export async function deleteCategory(id) {
  const { data } = await api.delete(`/categories/${id}`);
  return data;
}
